import React, { useState } from "react";
import { BG, LINE, BURGUNDY, INK_2, INK_3 } from "../bureauTokens";

// disabled=true : raccourci sans backend réel derrière encore (Messagerie —
// voir Bureau.jsx) — reste cliquable (onClick, ex. toast "bientôt
// disponible"), seul le style reste estompé.
function ShortcutButton({ icon: Icon, label, badge, onClick, disabled }) {
  const [hover, setHover] = useState(false);
  const active = hover && !disabled;

  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className="relative flex flex-col items-start gap-2 text-left transition-all"
      style={{
        padding: 12,
        borderRadius: 10,
        background: disabled ? "#fff" : active ? "#fff" : BG,
        border: `1px solid ${active ? BURGUNDY : LINE}`,
        color: disabled ? INK_3 : active ? BURGUNDY : INK_2,
        fontSize: 11,
        fontWeight: 500,
        cursor: "pointer",
      }}
    >
      <span className="relative inline-flex" style={{ color: disabled ? INK_3 : BURGUNDY }}>
        <Icon size={17} />
        {badge > 0 && (
          <span
            className="absolute flex items-center justify-center text-white font-bold"
            style={{
              top: -7,
              left: 12,
              minWidth: 16,
              height: 16,
              padding: "0 4px",
              background: BURGUNDY,
              fontSize: 10,
              borderRadius: 999,
              border: "1.5px solid #fff",
              lineHeight: 1,
            }}
          >
            {badge}
          </span>
        )}
      </span>
      <span>{label}</span>
    </button>
  );
}

export default ShortcutButton;
